import React, { useRef, useState } from "react";
import PlayIcon from "../Assets/Icon/PlayIcon";
import MarkIcon from "../Assets/Icon/MarkIcon";
import CopyIcon from "../Assets/Icon/CopyIcon";
import Heart2Icon from "../Assets/Icon/Heart2Icon";
import PauseIcon from "../Assets/Icon/PauseIcon";
import LoadingIcon from "../Assets/Icon/LoadingIcon";
import LeftArrow from "../Assets/Icon/LeftArrow";
import RightArrow from "../Assets/Icon/RightArrow";
const VersePlayer = ({ src, verse, state, setState }) => {
  const playerTrack = useRef();
  const range = useRef();
  const [player, setPlayer] = useState({
    duration: { current: "0", max: "0" },
    loading: true,
    playing: false,
  });
  const copyToClipboard = (text) => {
    const textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();

    state.langTo === "EN"
      ? alert("تم نسخ الآية للحافظة!")
      : alert("verse copied to clipboard!");
  };
  return (
    <>
      <audio
        className="hidden"
        ref={playerTrack}
        src={src}
        loop
        autoPlay
        onLoadStart={() => {
          setPlayer({
            ...player,
            loading: true,
            playing: false,
          });
        }}
        onCanPlayThrough={(e) => {
          setPlayer({
            ...player,
            duration: { ...player.duration, max: e.target.duration },
            loading: false,
          });
        }}
        onPlay={() => {
          setPlayer({
            ...player,
            playing: true,
          });
        }}
        onPause={() => {
          setPlayer({
            ...player,
            playing: false,
          });
        }}
        onTimeUpdate={(e) => {
          setPlayer({
            ...player,
            duration: {
              ...player.duration,
              current: e.target.currentTime,
            },
            loading: false,
          });
          // range.current.value = e.target.currentTime;
        }}
        onSeeking={() => {
          setPlayer({
            ...player,
            loading: true,
          });
        }}
      ></audio>
      <div className="arrow flex justify-evenly mt-10">
        <button
          className={
            state.selectedVerse === 1 ? "opacity-50 pointer-events-none" : null
          }
          onClick={() => {
            state.selectedVerse > 1 &&
              localStorage.setItem("selectedVerse", state.selectedVerse - 1);
            setState({
              ...state,
              selectedVerse: state.selectedVerse - 1,
            });
          }}
        >
          <RightArrow />
        </button>
        <button
          className="play-Puse flex shrink-0 w-16 h-16 rounded-3xl cursor-pointer items-center justify-center bg-white"
          onClick={() =>
            playerTrack.current.paused && playerTrack.current.duration
              ? playerTrack.current.play()
              : playerTrack.current.pause()
          }
        >
          {player.loading ? (
            <LoadingIcon />
          ) : !player.playing ? (
            <PlayIcon />
          ) : (
            <PauseIcon />
          )}
        </button>
        <button
          className={
            state.selectedVerse ===
            state.selectedMemorizationSurah.numberOfAyahs
              ? "opacity-50 pointer-events-none"
              : null
          }
          onClick={() => {
            state.selectedVerse <
              state.selectedMemorizationSurah.numberOfAyahs &&
              localStorage.setItem("selectedVerse", state.selectedVerse + 1);
            setState({
              ...state,
              selectedVerse: state.selectedVerse + 1,
            });
          }}
        >
          <LeftArrow />
        </button>
      </div>
      <div className="surahReader text-center flex flex-col">
        <span className="font-bold text-sm mt-4 text-[var(--MColor)]">
          {state.langTo === "EN"
            ? state.selectedMemorizationSurah.name
                .replace(/[\u064B-\u065F|\u06E1]/g, "")
                .replaceAll("ٱ", "ا")
                .replaceAll("ىٰ", "ى")
                .replaceAll("مٰ", "م") +
              " : " +
              state.selectedVerseReader.name
            : state.selectedMemorizationSurah.englishName +
              " : " +
              state.selectedVerseReader.englishName}
        </span>
      </div>
      <div className="player flex gap-4 items-center justify-center mt-4 relative">
        {/* <input
          step=".01"
          className="w-full absolute bottom-14 sm:relative sm:bottom-auto"
          style={{
            backgroundSize:
              (player.duration.current * 100) / player.duration.max + "% 100%",
          }}
          type="range"
          max={player.duration.max}
          ref={range}
          onChange={(e) => {
            playerTrack.current.currentTime = e.target.value;
            setPlayer({
              ...player,
              duration: {
                ...player.duration,
                current: e.target.value,
              },
            });
          }}
        /> */}
        <button
          className="group w-[73px] cursor-pointer shrink-0 flex flex-col items-center"
          onClick={() => {
            localStorage.favVerse
              ? localStorage.favVerse.includes(JSON.stringify(verse))
                ? (localStorage.favVerse = localStorage.favVerse
                    .replace("," + JSON.stringify(verse), "")
                    .replace(JSON.stringify(verse) + ",", "")
                    .replace(JSON.stringify(verse), ""))
                : (localStorage.favVerse += "," + JSON.stringify(verse))
              : (localStorage.favVerse = JSON.stringify(verse));

            setState({ ...state, favVerse: localStorage.favVerse });
          }}
        >
          <Heart2Icon
            color={state.favVerse.includes(JSON.stringify(verse)) && "#00ad67"}
          />
          <span className=" text-sm opacity-0 transition-all group-hover:opacity-100">
            {state.langTo === "EN" ? "أحببته" : "Like"}
          </span>
        </button>
        <button
          className="group w-[73px] cursor-pointer shrink-0 flex flex-col items-center"
          onClick={() => {
            localStorage.markVerse = JSON.stringify(verse);
            setState({ ...state, markVerse: localStorage.markVerse });
          }}
        >
          <MarkIcon
            color={
              state.markVerse === JSON.stringify(verse) ? "#00ad67" : "#000"
            }
          />
          <span className=" text-sm opacity-0 transition-all group-hover:opacity-100">
            {state.langTo === "EN" ? "ضع علامة" : "Mark verse"}
          </span>
        </button>
        <button
          className="group w-[73px] cursor-pointer shrink-0 flex flex-col items-center"
          onClick={() => copyToClipboard(verse.text)}
        >
          <CopyIcon />
          <span className=" text-sm opacity-0 transition-all group-hover:opacity-100">
            {state.langTo === "EN" ? "نسخ الآية" : "Copy verse"}
          </span>
        </button>
      </div>
    </>
  );
};

export default VersePlayer;
